import { render, staticRenderFns } from "./OrdersView.vue?vue&type=template&id=4ee8f92d&scoped=true"
import script from "./OrdersView.vue?vue&type=script&lang=js"
export * from "./OrdersView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee8f92d",
  null
  
)

export default component.exports